var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoAgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4831 102.234C42.7328 100.484 39.6074 100.484 37.8571 102.234L4.10216 136.02C-1.36739 141.49 -1.36739 150.428 4.10216 155.898C9.57171 161.367 18.5105 161.367 23.9801 155.898L57.7663 122.112C59.6103 120.268 59.6103 117.299 57.7663 115.486L44.4831 102.234Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.741 112.516C134.812 112.516 159.999 87.3288 159.999 56.2582C159.999 25.1877 134.812 0 103.741 0C72.6707 0 47.483 25.1877 47.483 56.2582C47.483 87.3288 72.6707 112.516 103.741 112.516Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7706 76.2613C93.6461 76.2613 96.8028 73.1046 96.8028 69.229V62.1967H110.867V69.229C110.867 73.1046 114.024 76.2613 117.9 76.2613C121.775 76.2613 124.932 73.1046 124.932 69.229V41.1312C124.932 37.2556 121.775 34.0989 117.9 34.0989C114.024 34.0989 110.867 37.2556 110.867 41.1312V48.1634H96.8028V41.1312C96.8028 37.2556 93.6461 34.0989 89.7706 34.0989C85.895 34.0989 82.7383 37.2556 82.7383 41.1312V69.229C82.7383 73.1358 85.895 76.2613 89.7706 76.2613Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.82589,
    y1: 155.25,
    x2: 144.256,
    y2: 15.4128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4.93249,
    y1: 155.356,
    x2: 144.363,
    y2: 15.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 103.835,
    y1: 76.2766,
    x2: 103.835,
    y2: 34.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAgent);
export default __webpack_public_path__ + "static/media/picto_agent.1b690fb013dbe0226c0d5f8c4937b3d4.svg";
export { ForwardRef as ReactComponent };